import { useMemo } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { Box, Button, Stack, useColorMode, useToast } from '@chakra-ui/react'
import { MoonIcon, SunIcon } from '@chakra-ui/icons'
import styled from '@emotion/styled'

import { signOut } from 'firebase/auth'
import { auth } from 'services/firebase'
import { FirebaseError } from '@firebase/util'

import { userContext } from 'context/userContext'

export const TopNav = () => {
  const { colorMode, toggleColorMode } = useColorMode()
  const navigate = useNavigate()
  const location = useLocation()
  const toast = useToast()
  const pathname = useMemo(() => location.pathname, [location])
  const isLogin = pathname === '/login'
  const isSignup = pathname === '/signup'

  const renderColorMode = () => {
    if (colorMode === 'light') {
      return <MoonIcon />
    } else {
      return <SunIcon />
    }
  }

  const handleLogout = () => {
    signOut(auth)
      .then(() => {
        toast({
          title: 'Logged out successfully',
          status: 'success',
          isClosable: true,
        })
        navigate('/')
      })
      .catch((error) => {
        if (error instanceof FirebaseError) {
          toast({
            title: 'Error while logging out',
            description: error.message,
            status: 'error',
            isClosable: true,
          })
        }
      })
  }

  return (
    <userContext.Consumer>
      {({ user: { data, loading } }) => (
        <Box padding={8}>
          <Stack direction='row' justify='end' spacing={4}>
            <Button variant='ghost' onClick={toggleColorMode}>
              {renderColorMode()}
            </Button>

            <LinkButton variant='link' onClick={() => navigate('/')}>
              Home
            </LinkButton>

            {loading && !data ? (
              <></>
            ) : data ? (
              <>
                <LinkButton variant='link' onClick={() => navigate('/searches')}>
                  Searches
                </LinkButton>
                <LinkButton variant='link' onClick={handleLogout}>
                  Logout
                </LinkButton>
              </>
            ) : (
              <>
                {!isLogin ? (
                  <LinkButton variant='link' onClick={() => navigate('/login')}>
                    Login
                  </LinkButton>
                ) : null}

                {!isSignup ? (
                  <LinkButton variant='link' onClick={() => navigate('/signup')}>
                    Sign up
                  </LinkButton>
                ) : null}
              </>
            )}
          </Stack>
        </Box>
      )}
    </userContext.Consumer>
  )
}

const LinkButton = styled(Button)`
  &:hover {
    text-decoration: none;
    opacity: 60%;
  }
`
